import '../styles/index.css';

export interface SystemMessageProps {
  text: string;
}

export function SystemMessage({ text }: SystemMessageProps) {
  return (
    <div className="pawa-system-container pawa-chat-item">
      <div className="pawa-system-message">{text}</div>
    </div>
  );
}
